/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShareGamificationModelResponse
 */
export interface ShareGamificationModelResponse {
    /**
     * CDN URL for the share card image
     * @type {string}
     * @memberof ShareGamificationModelResponse
     */
    shareCardUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ShareGamificationModelResponse
     */
    platform: ShareGamificationModelResponsePlatformEnum;
}


/**
 * @export
 */
export const ShareGamificationModelResponsePlatformEnum = {
    TWITTER: 'TWITTER',
    DISCORD: 'DISCORD',
    COPY_LINK: 'COPY_LINK'
} as const;
export type ShareGamificationModelResponsePlatformEnum = typeof ShareGamificationModelResponsePlatformEnum[keyof typeof ShareGamificationModelResponsePlatformEnum];


/**
 * Check if a given object implements the ShareGamificationModelResponse interface.
 */
export function instanceOfShareGamificationModelResponse(value: object): value is ShareGamificationModelResponse {
    if (!('shareCardUrl' in value) || value['shareCardUrl'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function ShareGamificationModelResponseFromJSON(json: any): ShareGamificationModelResponse {
    return ShareGamificationModelResponseFromJSONTyped(json, false);
}

export function ShareGamificationModelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareGamificationModelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'shareCardUrl': json['shareCardUrl'],
        'platform': json['platform'],
    };
}

export function ShareGamificationModelResponseToJSON(json: any): ShareGamificationModelResponse {
    return ShareGamificationModelResponseToJSONTyped(json, false);
}

export function ShareGamificationModelResponseToJSONTyped(value?: ShareGamificationModelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shareCardUrl': value['shareCardUrl'],
        'platform': value['platform'],
    };
}

